<template>
  <span class="pm-progress">
    <span class="pm-progress__bar" :class="tone ? 'pm-progress__bar--' + tone : ''"><i :style="{width: width + '%'}"></i></span>
    <span>{{ label || width + '%' }}</span>
  </span>
</template>

<script>
  export default {
    name: 'ProgressBar',
    props: {
      value: {},
      tone: {type: String, default: ''},
      label: {type: String, default: ''}
    },
    computed: {
      width() {
        let value = parseInt(this.value, 10) || 0;
        return Math.max(0, Math.min(100, value));
      }
    }
  }
</script>
